// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OAnIL","content":"styles_content__3QzB5"};